import createClient from 'openapi-fetch';
import type { paths } from './generated/entitlements';
import { runtimeEnv } from '../runtimeEnv';

// Typed client over the entitlements API; regenerate types via `npm run generate:api`.
export const api = createClient<paths>({ baseUrl: runtimeEnv.entitlementsApiUrl });

export const bearer = (token: string) => ({ Authorization: `Bearer ${token}` });
